import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import LeetCodeCard from "./components/LeetCodeCard";
import GitHubStatsCard from "./components/GitHubStatsCard";
import ActivityOverviewCard from "./components/ActivityOverviewCard";
import GitHubContributionCalendar from "./components/GitHubContributionCalendar";
import SpringboardBadgeCard from "./components/SpringboardBadgeCard";
import "./MyActivity.css";

const MyActivity = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const springboardBadges = [
    {
      emoji: "🗡️",
      title: "Duelist",
      category: "Problem Solving Milestone",
      certificatePath: "/certificates/certificatedetail/infosys-springboard-certificates"
    },
    {
      emoji: "🪖",
      title: "Fledgling",
      category: "Foundational Engineering",
      certificatePath: "/certificates/certificatedetail/infosys-springboard-certificates"
    },
    {
      emoji: "🛡️",
      title: "Warrior",
      category: "Consistency & Resilience",
      certificatePath: "/certificates/certificatedetail/infosys-springboard-certificates"
    }
  ];

  return (
    <div className="activity-container">
      <div className="activity-content-wrapper">
        {/* Section Header */}
        <header className="activity-header" data-aos="fade-down">
          <h1 className="activity-heading">MY ACTIVITY</h1>
          <p className="activity-subtitle">
            Consistent learning, coding, and contribution.
          </p>
        </header>

        {/* 3-Column Activity Cards Grid (Desktop), 2-Col (Tablet), 1-Col (Mobile) */}
        <section
          className="activity-top-grid"
          data-aos="fade-up"
          aria-label="Developer Activity Statistics"
        >
          <LeetCodeCard />
          <GitHubStatsCard />
          <ActivityOverviewCard />
        </section>

        {/* Dedicated Full-Width GitHub Contribution Heatmap */}
        <section
          className="activity-heatmap-section"
          data-aos="fade-up"
          aria-label="GitHub Contribution Activity"
        >
          <GitHubContributionCalendar />
        </section>

        {/* Infosys Springboard Badges */}
        <section
          className="activity-badges-section"
          data-aos="fade-up"
          aria-label="Infosys Springboard Badges"
        >
          <div className="badges-header">
            <h2 className="badges-title">🎓 Infosys Springboard Badges</h2>
            <p className="badges-subtitle">
              Verified achievement badges recognized in programming foundations and problem solving.
            </p>
          </div>

          <div className="badges-grid">
            {springboardBadges.map((badge, index) => (
              <SpringboardBadgeCard
                key={index}
                emoji={badge.emoji}
                title={badge.title}
                category={badge.category}
                certificatePath={badge.certificatePath}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default MyActivity;
